<template>
  <div
    class="chat_correspondence d-flex flex-column justify-end py-2 px-5 gap-7 w-100"
    :class="{
      'chat_correspondence--loading': chatIsLoading,
      'chat_correspondence--freeze': freeze,
    }"
    @context="$refs.ChatContextMenu && $refs.ChatContextMenu.onContext($event)"
  >
    <div class="loader" v-if="chatIsLoading">
      <LoadingAnimation />
    </div>
    <template v-if="messagesFormated.length">
      <ChatCorrespondenceUser
        v-for="(item, itemKey) in messagesFormated"
        :key="'chat_' + $route.params.id + '__key_' + itemKey"
        :item="item"
        :chatItem="chatItem"
        :onFindUserById="onFindUserById"
        @context="$refs.ChatContextMenu && $refs.ChatContextMenu.onContext($event)"
        :observer="observer"
      />
      <ChatContextMenu
        v-model="messageObj"
        ref="ChatContextMenu"
        :items="returnContextItems"
        @showMenu="changeShowMenu"
      />
    </template>
    <div class="f16 noData py-2 px-5 d-flex align-center justify-center gap-3 w-100 h-100" v-else>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 1.01148e-06H2C0.897 1.01148e-06 0 0.894001 0 1.992V14.008C0 15.106 0.897 16 2 16H5V20L11.351 16H18C19.103 16 20 15.106 20 14.008V1.992C19.9984 1.46279 19.7869 0.95583 19.412 0.582372C19.037 0.208914 18.5292 -0.000531115 18 1.01148e-06ZM14.707 11.293L13.293 12.707L10 9.414L6.707 12.707L5.293 11.293L8.586 8L5.293 4.707L6.707 3.293L10 6.586L13.293 3.293L14.707 4.707L11.414 8L14.707 11.293Z"
          fill="#3B3B3B"
        />
      </svg>
      {{ localStorage.translations.pages.common['text']['net-dannyh'] }}
    </div>
    <ChatModalRecordVideo :chatItem="chatItem" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import _ from 'lodash'
import ChatCorrespondenceUser from 'components/chat/correspondence/ChatCorrespondenceUser'
import ChatContextMenu from 'components/chat/contextMenu/ChatContextMenu'
import ChatModalRecordVideo from 'components/chat/modal/ChatModalRecordVideo'
import LoadingAnimation from 'components/LoadingAnimation'

export default {
  name: 'ChatCorrespondence',
  components: {
    ChatCorrespondenceUser,
    ChatContextMenu,
    ChatModalRecordVideo,
    LoadingAnimation,
  },
  props: {
    chatItem: { type: Object },
    onFindUserById: Function,
    onChatModalOpen: Function,
  },
  data() {
    return {
      observer: null,
      messageObj: null,
      waitSeen: {},
      messagesInWatchNow: [],
      loading: false,
      freeze: false,
    }
  },
  created() {
    this.onElementObserver()
  },
  mounted() {
    this.onAutoScrollToLastSeenMessage()
  },
  watch: {
    waitSeen() {
      console.log('waitSeen', this.waitSeen)
    },
    '$route.params.id'() {
      this.messagesInWatchNow = []
      this.onAutoScrollToLastSeenMessage()
    },
    messagesInWatchNow() {
      this.$emit('messagesInWatchNow', this.messagesInWatchNow)
    },
  },
  computed: {
    ...mapGetters('user', ['userData']),
    ...mapState('chat', ['chatIsLoading']),
    ...mapState('chat/messages', ['chatSelectedMessages']),
    ...mapGetters('chat/messages', ['chatSelectedMessagesAllFromCurrentUser']),
    messagesFormated() {
      let result = []
      const messages = this.chatItem.messages
      for (let messKey in messages) {
        let data = {
          senderId: messages[messKey].senderId,
          messages: [messages[messKey]],
          key: messKey,
        }
        let findResult = result.find((i) => i.key == messKey - 1)
        if (findResult && findResult.senderId === messages[messKey].senderId) {
          findResult.messages.push(messages[messKey])
          findResult.key = messKey
        } else result.push(data)
      }
      this.onAutoScrollToLastSeenMessage(true)
      return result
    },
    messagesUnseen() {
      const messageLength = this.chatItem.messages.length - 1
      return {
        messageId: messageLength ? this?.chatItem?.messages[messageLength]?.id : null,
        counter: this?.chatItem?._count?.messages,
        chatId: this.chatItem.id,
      }
    },
    contextItems() {
      const userIsSender = this.messageObj && this.userData.id === this.messageObj.senderId
      return this.messageObj
        ? [
            {
              if: userIsSender && this.messageObj.status === 'error',
              title: this.localStorage.translations.pages.common.buttons.repeat,
              icon: 'chat-repeat',
              click: () =>
                this.messageObj.target.parentElement.__vue__ &&
                this.messageObj.target.parentElement.__vue__.onSendMessage(),
            },
            {
              if:
                userIsSender &&
                !this.messageObj.status &&
                (this.messageObj.content !== null || this.messageObj.attachments.length > 0) &&
                !this.chatSelectedMessages.length,
              title: this.localStorage.translations.pages.common.buttons.redaktirovat,
              icon: 'chat-edit',
              click: () => this.SELECT_chatMessageEdit(this.messageObj),
            },
            {
              if:
                !this.messageObj.status &&
                this.messageObj.content !== null &&
                !this.chatSelectedMessages.length,
              title: this.localStorage.translations.pages.common.buttons['copy-text'],
              icon: 'chat-copy',
              click: () => navigator.clipboard.writeText(this.messageObj.content),
            },
            {
              if: !this.messageObj.status && !this.chatSelectedMessages.length,
              title: this.localStorage.translations.pages.common.buttons.share,
              icon: 'chat-share',
              click: () =>
                this.onChatModalOpen({ type: 'SHARE', messagesId: [this.messageObj.id] }),
            },
            {
              if:
                userIsSender &&
                this.messageObj.status === 'error' &&
                !this.chatSelectedMessages.length,
              title: this.localStorage.translations.pages.common.buttons.udalit,
              icon: 'chat-trash',
              click: () =>
                this.SET_deleteMessage({
                  messageId: this.messageObj.id,
                  chatId: this.messageObj.chatId,
                }),
            },
            {
              if: userIsSender && !this.messageObj.status && !this.chatSelectedMessages.length,
              title: this.localStorage.translations.pages.common.buttons.udalit,
              icon: 'chat-trash',
              click: () =>
                this.DELETE_chatMessage({
                  messageId: this.messageObj.id,
                }),
            },
            {
              if:
                this.messageObj.id &&
                !this.messageObj.status &&
                this.chatSelectedMessages.length &&
                Boolean(this.chatSelectedMessages.find((i) => i.id === this.messageObj.id)),
              title:
                this.localStorage.translations.pages.common.buttons.share +
                ' (' +
                this.chatSelectedMessages.length +
                ')',
              icon: 'chat-share',
              click: () =>
                this.onChatModalOpen({
                  type: 'SHARE',
                  messagesId: this.chatSelectedMessages.map((i) => i.id),
                }),
            },
            {
              if:
                this.messageObj.id &&
                !this.messageObj.status &&
                this.chatSelectedMessages.length &&
                Boolean(this.chatSelectedMessages.find((i) => i.id === this.messageObj.id)) &&
                this.chatSelectedMessagesAllFromCurrentUser,
              title:
                this.localStorage.translations.pages.common.buttons.udalit +
                ' (' +
                this.chatSelectedMessages.length +
                ')',
              icon: 'chat-trash',
              click: () => this.DELETE_chatSelectedMessages(),
            },
            ...this.contextSelectItem,
          ]
        : []
    },
    contextSelectItem() {
      return [
        {
          if: this.messageObj && !this.messageObj.status,
          title: this.localStorage.translations.pages.common.buttons.select,
          icon: 'chat-select',
          click: () =>
            this.SELECT_chatSelectedMessages({
              id: this.messageObj.id,
              senderId: this.messageObj.senderId,
              chatId: this.messageObj.chatId,
            }),
        },
      ]
    },
    returnContextItems() {
      return this.messageObj &&
        this.messageObj.target &&
        this.messageObj.target.classList.contains('wrapper')
        ? !Boolean(this.chatSelectedMessages.find((i) => i.id === this.messageObj.id))
          ? this.contextSelectItem
          : this.contextItems
        : this.contextItems
    },
  },
  methods: {
    ...mapMutations('chat/messages', ['SET_countUnseen', 'SET_deleteMessage']),
    ...mapActions('chat/messages', [
      'SELECT_chatMessageEdit',
      'READ_chatMessages',
      'DELETE_chatMessage',
      'DELETE_chatSelectedMessages',
      'SELECT_chatSelectedMessages',
    ]),
    onElementObserver() {
      this.observer = new IntersectionObserver(this.onElementObserved, {
        root: this.$el,
        threshold: 0.25,
      })
    },
    onReadMessage(date) {
      this.READ_chatMessages({
        messageIds: this.waitSeen[date],
        chatId: this.chatItem.id,
      }).then(() => delete this.waitSeen[date])
    },
    onSeen(messageIds) {
      let delay = 2 * 1000
      let findKey = Object.keys(this.waitSeen).find(
        (i) => i <= Date.now() && i >= Date.now() - delay,
      )
      for (let messageId of messageIds) {
        const finnMessage = this.chatItem.messages.find((i) => i.id === messageId)
        finnMessage.isSeen = true
      }
      if (findKey) {
        this.waitSeen[findKey].push(...messageIds)
      } else {
        const dateNow = Date.now()
        const _this = this
        this.waitSeen[dateNow] = messageIds
        setTimeout(function () {
          _this.onReadMessage(dateNow)
        }, delay)
      }
    },
    onElementObserved(entries, observer) {
      //console.log('onElementObserved', entries)
      const messagesUnSeenIds = []
      entries.forEach(({ target, isIntersecting }) => {
        // console.log('entries', { target, isIntersecting })
        const targetId = Number(target.getAttribute('data-id'))
        const targetUnSeen = target.getAttribute('data-unSeen')
        // console.log('isIntersecting', targetId + '_' + isIntersecting)
        if (isIntersecting) {
          // console.log('id + ', targetId)   this.messagesInWatchNow.push(Number(targetId))
          if (targetUnSeen) {
            messagesUnSeenIds.push(targetId)
            this.SET_countUnseen({ chatId: this.chatItem.id, count: -1 })
          }
          this.messagesInWatchNow.push(targetId)
        } else {
          let delIndex = this.messagesInWatchNow.indexOf(targetId)
          // console.log('targetIndex', delIndex)
          if (delIndex > -1) {
            this.$delete(this.messagesInWatchNow, delIndex)
            // console.log('id - ', targetId)
          }
        }
        // this.observer.unobserve(target)
      })
      // console.log('messagesUnSeenIds', messagesUnSeenIds)
      // console.log('messagesInWatchNow', this.messagesInWatchNow)
      if (messagesUnSeenIds.length) {
        this.onSeen(messagesUnSeenIds)
      }
    },
    onAutoScrollToLastSeenMessage(smooth) {
      // console.log('onAutoScrollToLastSeenMessage')
      if (this.chatItem.messages.length) {
        this.$nextTick(function () {
          if (this.messagesUnseen.messageId) {
            const targetId = 'message_' + this.messagesUnseen.messageId
            this.$scrollToElementById({
              targetId,
              smooth: smooth,
              block: this.messagesUnseen.messageId ? null : 'end',
            })
          } else if (
            !this.messagesUnseen.messageId ||
            this.messagesUnseen.messageId === this.chatItem.messages[0].id
          ) {
            const target = this.$el.parentElement
            // console.log('target', target)
            this.$scrollToBottom({ target, smooth: smooth })
          }
        })
      }
    },
    changeShowMenu(v) {
      this.$el.parentElement.style.overflowY = v ? 'hidden' : 'auto'
    },
  },
  beforeDestroy() {
    this.observer.disconnect()
  },
}
</script>

<style lang="scss" scoped>
.chat_correspondence {
  // position: relative;
  // transition: 0.3s;
  // &--loading {
  //   filter: blur(10px);
  // }
  .loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
